export function isValidFilename(input) {
  const minimalLength = input.length > 2
  const withoutWildCards = input.replace(/%[^%]+%/gm, '')
  const validChars = !withoutWildCards.match(/[\s@$%&\\/:*?"'<>|~`#^+={}[\];!]/igm)

  return minimalLength && validChars
}
